export default {
  strings: {}
};